import { useTranslation, Trans } from 'next-i18next';
import React, { useState, useContext } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { CoreContext } from '../../context/index.js';
import { w as withProviders } from '../../withProviders-l3mjYkR2.js';
import { setUserInformation, setUserCart } from '../../utils/salesforce.js';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import { T as TERMS_AND_CONDITIONS, h as PRIVACY_POLICY } from '../../paths-ZKN3m62_.js';
import '../../payment-YC9H491Y.js';
import useAutoFocus from '../../hooks/useAutoFocus.js';
import useCaptcha from '../../hooks/useCaptcha.js';
import '../../index-zNO-4REJ.js';
import 'next/router';
import useShowError from '../../hooks/useShowError.js';
import useShowNotify from '../../hooks/useShowNotify.js';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import '../../helpers-kA_hdoOI.js';
import 'lodash';
import { getValidationSchema, initialValues } from './form/index.js';
import Button from '../Button/index.js';
import ButtonGroup from '../ButtonGroup/index.js';
import '../../index-2586sEvh.js';
import { I as Input } from '../../Input-quQLghm0.js';
import { I as InputPassword } from '../../InputPassword-SnmSpVSN.js';
import Link from '../Link/index.js';
import Loader from '../Loader/index.js';
import { C as Checkbox } from '../../Checkbox-o9DWtxXo.js';
import { H as HCaptchaComponent } from '../../HCaptcha-z_AMrNS9.js';
import { G as GetHCaptchaToken } from '../../GetHCaptchaToken-sJpm0bg0.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import { extractErrorMessage } from '../../utils/error.js';
import '../../utils/currency.js';
import { RegisterFormType } from '../../types/index.js';
import { getCartSessionId } from '../../utils/cart.js';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { subscribeEmailToNewsletter } from '../../services/newsletter/index.js';
import usePasswordMatch from '../../hooks/usePasswordMatch.js';
import 'react-i18next';
import 'notistack';
import '../../utils/cookies.js';
import '../../cookies-l-jEMp6P.js';
import '../../utils/isBot.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import '../../index-RkBJ48Nr.js';
import '../../storeSelectors/captcha.js';
import 'i18next';
import '../../index-V63xQvL7.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../utils/product.js';
import 'yup';
import '@hookform/resolvers/yup';
import '../../utils/validation.js';
import '../../validation-AjMAVn7m.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../modal-6vnX5SO3.js';
import '../CircularProgress/index.js';
import 'next/link';
import '@hcaptcha/react-hcaptcha';
import '../../MergeCarts-wo9UjKo5.js';
import '../../ProcessReactivateCart-fk5bSKoR.js';
import '../../requestsCollection-gritD79O.js';
import '../../services/auth/index.js';
import '../../utils/fetchPolicyLookup.js';
import '../../utils/price.js';
import 'number-currency-format';
import '../../cart-Vtx0Wqgk.js';
import '../../utils/date.js';
import 'date-fns';

const RegisterForm = ({ formType, loginFormValues, showHCaptcha, showDisclaimer, brandSubscribeCheckbox = false, siteSubscribeCheckbox = false, accorSubscribeCheckbox = false, validateHCaptchaTokenOnServer, onSubmitted, onBack, onShowNotify, }) => {
    var _a, _b;
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { t: tValidation } = useTranslation('', { keyPrefix: '$common.$validation' });
    const [serverError, setServerError] = useState(null);
    const [captchaLoading, setCaptchaLoading] = useState(false);
    const showErrorNotify = useShowError();
    const { useDispatch, useGetLoadingStatus, thunks, data, apolloConfig, data: { siteConfig: { parentHotelCompany, catalogId, accorTagging: { accorTaggingEnabled = false } = {}, region, }, }, } = useContext(CoreContext);
    const { siteName, hotelBrandName } = data.siteConfig;
    const showNotifyHook = useShowNotify();
    const showNotify = onShowNotify || showNotifyHook;
    const dispatch = useDispatch();
    const { user, cart: { getCart }, } = thunks;
    const isLoading = useGetLoadingStatus(user.register);
    const { isFulfilled: isCaptchaFulfilled, captcha } = useCaptcha();
    const showCaptcha = isCaptchaFulfilled && captcha.account_creation;
    const captchaSiteKey = captcha.public_key;
    const { register, control, handleSubmit, setValue, setError, clearErrors, formState: { errors, isValid }, trigger, } = useForm({
        resolver: getValidationSchema(showCaptcha && showHCaptcha, formType),
        defaultValues: { ...initialValues, ...loginFormValues },
        mode: 'onSubmit',
    });
    // This triggers the validation on confirmPassword when password changes.
    usePasswordMatch(useWatch, trigger, control);
    const onSubmit = async ({ captcha: _, ...restValues }) => {
        var _a;
        const resultAction = await dispatch(user.register(restValues));
        if (user.register.fulfilled.match(resultAction)) {
            const agreeSubscribe = restValues.createAccountAgreeSubscribe;
            showNotify(tValidation('loginSuccess'));
            const accorSubscriptionText = restValues.brandSubscribe || restValues.accorSubscribe
                ? `AllAccor_${restValues.accorSubscribe ? 'Brand' : ''}${restValues.brandSubscribe ? 'News' : ''}`
                : null;
            const subscribePromise = agreeSubscribe
                ? subscribeEmailToNewsletter(region, data.locale, catalogId, window.location.origin, window.location.href, restValues.email, 'account')
                : Promise.resolve(null);
            const accorPromise = accorSubscriptionText
                ? subscribeEmailToNewsletter(region, data.locale, catalogId, window.location.origin, window.location.href, restValues.email, 'account', accorSubscriptionText)
                : Promise.resolve(null);
            setUserInformation(catalogId, restValues.email);
            try {
                if (agreeSubscribe || accorSubscriptionText) {
                    await Promise.all([subscribePromise, accorPromise]);
                }
            }
            catch (e) {
                showErrorNotify(extractErrorMessage(e));
            }
            const cart = await dispatch(getCart({ cart_id: getCartSessionId(), accorTaggingEnabled }));
            if ('items' in cart.payload)
                setUserCart(cart.payload);
            onSubmitted();
        }
        else if (isRejectedWithValue(resultAction)) {
            if (((_a = resultAction.error) === null || _a === void 0 ? void 0 : _a.message) === 'Rejected') {
                setServerError(t('$common.$pages.$checkout.accountAlreadyRegistered'));
            }
            else {
                setServerError(resultAction.payload.errorMessage);
            }
        }
    };
    const handleCaptchaVerify = async (token) => {
        setCaptchaLoading(true);
        const success = await validateHCaptchaTokenOnServer(apolloConfig, token, GetHCaptchaToken);
        if (success) {
            setValue('captcha', token);
            clearErrors('captcha');
        }
        else {
            setValue('captcha', null);
            // TODO: add translation
            setError('captcha', { message: 'Captcha token is invalid' });
        }
        setCaptchaLoading(false);
    };
    const handleCaptchaExpire = () => {
        setValue('captcha', null);
        setError('captcha', { message: tValidation('captchaExpired') });
    };
    const focusOnLoad = formType === RegisterFormType.Drawer;
    const ref = useAutoFocus({ tag: 'input', focusOnLoad });
    if (formType === RegisterFormType.Drawer) {
        return (React.createElement("form", { className: "auth-form", onSubmit: handleSubmit(onSubmit) },
            React.createElement("fieldset", null,
                React.createElement("legend", { className: "sr-only" }, tButton('register')),
                React.createElement("div", { ref: ref, className: "row" },
                    React.createElement(Input, { id: "register-email", name: "email", autocomplete: "email", label: `${tLabel('email')} *`, register: register, errors: errors, inputMode: "email" })),
                React.createElement("div", { className: "row" },
                    React.createElement(InputPassword, { id: "register-password", name: "password", control: control, autocomplete: "current-password", label: `${tLabel('password')} *`, extraLabel: tValidation('passwordRequirements'), errors: errors, title: tValidation('passwordRequirements') })),
                React.createElement("div", { className: "row" },
                    React.createElement(InputPassword, { id: "register-confirm-password", name: "confirmPassword", control: control, autocomplete: "current-password", label: `${tLabel('passwordConfirm')} *`, errors: errors, title: tValidation('passwordRequirements') })),
                showHCaptcha && (React.createElement("div", { className: "row" },
                    React.createElement(HCaptchaComponent, { siteKey: captchaSiteKey, error: (_a = errors.captcha) === null || _a === void 0 ? void 0 : _a.message, onVerify: handleCaptchaVerify, onExpire: handleCaptchaExpire }))),
                React.createElement("div", { className: "row" },
                    React.createElement(Checkbox, { name: "createAccountAgreeTerms", label: React.createElement("span", null,
                            t('$common.agreeWith_1'),
                            "\u00A0",
                            React.createElement(Link, { href: TERMS_AND_CONDITIONS, target: "_blank" },
                                React.createElement(Trans, { i18nKey: "termsAndConditions", t: tLabel, components: { span: React.createElement("span", null) } })),
                            "\u00A0",
                            t('$common.and'),
                            "\u00A0",
                            React.createElement(Link, { href: PRIVACY_POLICY, target: "_blank" }, tLabel('privacyPolicy')),
                            "\u00A0",
                            tLabel('ofThisSite', { siteName })), control: control, errors: errors })),
                siteSubscribeCheckbox && (React.createElement("div", { className: "row" },
                    React.createElement(Checkbox, { name: "createAccountAgreeSubscribe", label: React.createElement(Trans, { i18nKey: "$common.subscribeCheckboxCheckout", t: t, components: {
                                a: (
                                // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
                                React.createElement("a", { className: "base-link", rel: "noreferrer" })),
                            }, values: { siteName } }), control: control, errors: errors }))),
                accorSubscribeCheckbox && (React.createElement("div", { className: "row" },
                    React.createElement(Checkbox, { name: "accorSubscribe", control: control, errors: errors, label: React.createElement(Trans, { i18nKey: "$accorCommon.allSubscribeCheckbox", t: t, components: {
                                a: (
                                // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                                React.createElement("a", { className: "base-link", href: t('$accorCommon.allSubscribeCheckboxHref'), target: "_blank", rel: "noreferrer" })),
                            }, values: { siteName } }) }))),
                brandSubscribeCheckbox && parentHotelCompany === 'Accor' && (React.createElement(Checkbox, { name: "brandSubscribe", control: control, errors: errors, label: React.createElement(Trans, { i18nKey: "$accorCommon.$agreements.brandSubscribeCheckbox", t: t, components: {
                            a: (
                            // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                            React.createElement("a", { className: "base-link", href: t('$accorCommon.$agreements.brandSubscribeCheckboxHref'), target: "_blank", rel: "noreferrer" })),
                        }, values: { brandName: hotelBrandName } }) })),
                React.createElement("div", { className: "row row-note" },
                    React.createElement("span", { className: "note", title: tLabel('requiredSignMeans') },
                        "* ",
                        tLabel('requiredFields'))),
                showDisclaimer && React.createElement("p", { className: "disclaimer" }, t('$common.disclaimer', { siteName })),
                React.createElement(ButtonGroup, { vertical: "max-480" },
                    React.createElement(Button, { type: "button", variant: "plain", className: "btn", disabled: isLoading, onClick: onBack }, tButton('back')),
                    isLoading ? (React.createElement(Loader, null)) : (React.createElement(Button, { type: "submit", disabled: isLoading ||
                            (!isValid && Object.keys(errors).length > 0) ||
                            (showHCaptcha ? captchaLoading : false) }, tButton('register')))),
                serverError && (React.createElement("div", { role: "alert", id: "serverError", className: "error-ui" }, t(serverError))))));
    }
    if (formType === RegisterFormType.Page) {
        return (React.createElement("fieldset", null,
            React.createElement("legend", null,
                React.createElement("h1", { className: "title" }, tLabel('register'))),
            React.createElement("form", { className: "auth-form", onSubmit: handleSubmit(onSubmit) },
                React.createElement("div", { ref: ref, className: "row" },
                    React.createElement("div", { className: "part" },
                        React.createElement("div", { className: "form-block padding-container" },
                            React.createElement("div", { className: "row" },
                                React.createElement(Input, { name: "firstname", id: "firstname", autocomplete: "given-name", label: `${tLabel('firstName')} *`, placeholder: `${tLabel('firstName')} *`, register: register, errors: errors })),
                            React.createElement("div", { className: "row" },
                                React.createElement(Input, { name: "lastname", id: "lastname", autocomplete: "family-name", label: `${tLabel('lastName')} *`, placeholder: `${tLabel('lastName')} *`, register: register, errors: errors })),
                            React.createElement("div", { className: "row" },
                                React.createElement(Input, { name: "email", id: "email", autocomplete: "email", label: `${tLabel('email')} *`, placeholder: `${tLabel('email')} *`, register: register, errors: errors, inputMode: "email" })),
                            React.createElement("div", { className: "row" },
                                React.createElement(InputPassword, { name: "password", id: "password", control: control, autocomplete: "new-password", label: `${tLabel('password')} *`, placeholder: `${tLabel('password')} *`, errors: errors, title: tValidation('passwordRequirements'), extraLabel: tValidation('passwordRequirements') })),
                            React.createElement("div", { className: "row" },
                                React.createElement(InputPassword, { id: "confirm-password", name: "confirmPassword", control: control, autocomplete: "current-password", label: `${tLabel('passwordConfirm')} *`, placeholder: `${tLabel('passwordConfirm')} *`, errors: errors, title: tValidation('passwordRequirements') })),
                            showHCaptcha && (React.createElement("div", { className: "row" },
                                React.createElement(HCaptchaComponent, { siteKey: captchaSiteKey, error: (_b = errors.captcha) === null || _b === void 0 ? void 0 : _b.message, onVerify: handleCaptchaVerify, onExpire: handleCaptchaExpire }))),
                            React.createElement("div", { className: "row" },
                                React.createElement(Checkbox, { name: "createAccountAgreeTerms", label: React.createElement("span", null,
                                        t('$common.agreeWith_1'),
                                        "\u00A0",
                                        React.createElement(Link, { href: TERMS_AND_CONDITIONS, target: "_blank" },
                                            React.createElement(Trans, { i18nKey: "termsAndConditions", t: tLabel, components: { span: React.createElement("span", null) } })),
                                        "\u00A0",
                                        t('$common.and'),
                                        "\u00A0",
                                        React.createElement(Link, { href: PRIVACY_POLICY, target: "_blank" }, tLabel('privacyPolicy')),
                                        "\u00A0",
                                        tLabel('ofThisSite', { siteName })), control: control, errors: errors })),
                            siteSubscribeCheckbox && (React.createElement("div", { className: "row" },
                                React.createElement(Checkbox, { name: "createAccountAgreeSubscribe", label: React.createElement(Trans, { i18nKey: "$common.subscribeCheckboxCheckout", t: t, components: {
                                            a: (
                                            // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
                                            React.createElement("a", { className: "base-link", rel: "noreferrer" })),
                                        }, values: { siteName } }), control: control, errors: errors }))),
                            accorSubscribeCheckbox && (React.createElement("div", { className: "row" },
                                React.createElement(Checkbox, { name: "accorSubscribe", control: control, errors: errors, label: React.createElement(Trans, { i18nKey: "$accorCommon.allSubscribeCheckbox", t: t, components: {
                                            a: (
                                            // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                                            React.createElement("a", { className: "base-link", href: t('$accorCommon.allSubscribeCheckboxHref'), target: "_blank", rel: "noreferrer" })),
                                        }, values: { siteName } }) }))),
                            brandSubscribeCheckbox && parentHotelCompany === 'Accor' && (React.createElement(Checkbox, { name: "brandSubscribe", control: control, errors: errors, label: React.createElement(Trans, { i18nKey: "$accorCommon.$agreements.brandSubscribeCheckbox", t: t, components: {
                                        a: (
                                        // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                                        React.createElement("a", { className: "base-link", href: t('$accorCommon.$agreements.brandSubscribeCheckboxHref'), target: "_blank", rel: "noreferrer" })),
                                    }, values: { brandName: hotelBrandName } }) })),
                            showDisclaimer && (React.createElement("p", { className: "disclaimer" }, t('$common.disclaimer', { siteName }))),
                            serverError && (React.createElement("div", { role: "alert", id: "serverError", className: "error-ui" }, t(serverError)))))),
                React.createElement(ButtonGroup, { vertical: "max-480" }, isLoading ? (React.createElement(Loader, null)) : (React.createElement(Button, { className: "btn", type: "submit", disabled: isLoading ||
                        (!isValid && Object.keys(errors).length > 0) ||
                        (showHCaptcha ? captchaLoading : false) }, tButton('signUp')))))));
    }
    return null;
};
var RegisterForm$1 = withProviders(RegisterForm, { translation: true, snackbar: true });

export { RegisterForm$1 as default };
//# sourceMappingURL=index.js.map
